import { html, unsafeCSS } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { BaseElement, customElement } from '../../../components/base-element';
import '../../../components/carousel';
import imgProStudio from './pro-studio.svg';
import imgAnalytics from './analytics.svg';
import imgManager from './manager.svg';
import imgContactCenter from './contact-center.svg';
import styles from './auth-card.scss?inline';

@customElement('ps-auth-card')
export class AuthCardWC extends BaseElement {
  static styles = unsafeCSS(styles);

  // @todo: restore slotted header & footer containers once Next.js not using dynamic imports
  // ${this.slotted('header')
  // ? html`<slot name="header" class="c-auth-card__header"></slot>`
  // : ''}
  // <slot class="c-auth-card__main"></slot>
  // ${this.slotted('footer')
  // ? html`<slot name="footer" class="c-auth-card__footer"></slot>`
  // : ''}

  render() {
    return html`
      <div
        class=${classMap({
          'c-auth-card': true,
          'c-auth-card--has-cover-img': true,
        })}
      >
        <div class="c-auth-card__content">
          <slot name="header" class="c-auth-card__header"></slot>
          <slot class="c-auth-card__main"></slot>
          <slot name="footer" class="c-auth-card__footer"></slot>
        </div>
        <div class="c-auth-card__slider">
          <ps-carousel autoplay>
            <ps-carousel-item>
              <img
                src=${imgProStudio}
                class="c-auth-card__slider-img"
                alt="ProStudio"
                width="552"
                height="612"
              />
            </ps-carousel-item>
            <ps-carousel-item>
              <img
                src=${imgAnalytics}
                class="c-auth-card__slider-img"
                alt="Analytics"
                width="552"
                height="612"
              />
            </ps-carousel-item>
            <ps-carousel-item>
              <img
                src=${imgManager}
                class="c-auth-card__slider-img"
                alt="Manager"
                width="552"
                height="612"
              />
            </ps-carousel-item>
            <ps-carousel-item>
              <img
                src=${imgContactCenter}
                class="c-auth-card__slider-img"
                alt="ContactCenter"
                width="552"
                height="612"
              />
            </ps-carousel-item>
          </ps-carousel>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-auth-card': AuthCardWC;
  }
}
